import React, { ComponentProps, ReactElement } from "react";

import ServiceProvider from "./ServiceProvider";
import { ServiceContainer } from "./ServiceRegistry";
import httpService from "../http/HttpService";
import sessionStorage from "../storage/SessionStorageService";
import useThemeService from "../theme-service/ThemeService";
import translationService from "../translation/TranslationService";
import configurationService from "../configuration/ConfigurationService";
import useAuthService from "../authentication/AuthService";
import apiService from "../api/ApiService";
import usePageTitle from "../page-title/PageTitleKey";
import browserService from "../browser-info/BrowserService";
import snackbarNotificationsService from "../notifications/SnackbarNotificationsService";
import useLocalStorage from "../storage/LocalStorageService";
import useErrorHandler from "../error-handler/ErrorHandlerService";
import useMainMenuStorage from "../main-menu/MainMenuStorageService";
import notificationsService from "../notifications/NotificationsService";
import useMsalProvider from "../../AppMsalProvider";
import networkStatus from "../../services/network-status/NetworkStatus";
import lockedInspectionsService from "../inspection/LockedInspectionStorage";
import warningLeavePageService from "../page/WarningLeavePageService";

export function withServices(
  WrappedComponent: React.ComponentType<any>,
  services: ServiceContainer<any, any>[]
) {
  return (props: any) => {
    return (
      <ServiceProvider services={services.map((x) => x.Provider)}>
        <WrappedComponent {...props}></WrappedComponent>
      </ServiceProvider>
    );
  };
}

function ComponentWrapper({ children }: ComponentProps<any>): ReactElement<any, any> {
  return <>{children}</>;
}

export default withServices(ComponentWrapper, [
  browserService,
  httpService,
  useLocalStorage,
  sessionStorage,
  translationService,
  snackbarNotificationsService,
  useErrorHandler,
  configurationService,
  useMsalProvider,
  useAuthService,
  apiService,
  lockedInspectionsService,
  useThemeService,
  usePageTitle,
  useMainMenuStorage,
  networkStatus,
  notificationsService,
  warningLeavePageService,
]);
